// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget_wrapper__1_NhL","wrapperBackgroundEnabled":"widget_wrapperBackgroundEnabled__34fWg","customWidget":"widget_customWidget__232e7"};